import { ref } from 'vue'

export const bootstrapReady = ref(false)
